import React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Skeleton from '@mui/material/Skeleton'
import Divider from '@mui/material/Divider'
import AdxEmployeeAvatar from 'components/reusable/employeeAvatar/AdxEmployeeAvatar'

const GeneratedGroupCard = ({ item, handleClickManageCustomCard, index, length }) => {
  const members = item.members?.map((item) => {
    return { name: item.name, imgUrl: item.profile_image_url }
  })

  return (
    <Box>
      <Box
        px={2}
        py={3}
        display="flex"
        flexDirection={{ xs: 'column', lg: 'row' }}
        justifyContent={{ xs: 'flex-start', lg: 'space-between' }}
        alignItems={{ xs: 'flex-start', lg: 'center' }}
      >
        <Box display="flex">
          <Box
            height="100%"
            display="flex"
            alignItems="center"
            gap={2}
            width="100%"
            maxWidth="700px"
          >
            <Box
              height="100%"
              display="flex"
              flexDirection="column"
              alignItems="left"
              justifyContent="center"
              gap={0.5}
            >
              <Typography variant="body1">{item.group_name || <Skeleton width={100} />}</Typography>
              <Typography variant="body2" color="light-gray-text.main">
                {item.group_description || ''}
              </Typography>
            </Box>
          </Box>
        </Box>
        <Box display="flex" alignItems="center" gap={2}>
          <Box display="flex">
            {Object.keys(item).length === 0 ? (
              <Skeleton width={100} height={45} />
            ) : (
              <AdxEmployeeAvatar data={members} max={5} tooltip variant />
            )}
          </Box>
          <Typography
            onClick={handleClickManageCustomCard}
            mx={2}
            noWrap
            variant="subtitle1"
            color={'alternate.main'}
            sx={{
              textDecoration: 'underline',
              fontWeight: 'medium',
              cursor: 'pointer',
            }}
          >
            View
          </Typography>
        </Box>
      </Box>
      {index + 1 !== length && <Divider />}
    </Box>
  )
}

export default GeneratedGroupCard
